var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _rect7, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.0395,
    y: 13.8432,
    width: 5,
    height: 6,
    rx: 1.5,
    transform: "rotate(30 33.0395 13.8432)",
    fill: "white",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4511,
    y: 4.84317,
    width: 5,
    height: 6,
    rx: 1.5,
    transform: "rotate(30 17.4511 4.84317)",
    fill: "white",
    stroke: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.183,
    y: 2.37833,
    width: 19,
    height: 17,
    rx: 1.5,
    transform: "rotate(30 21.183 2.37833)",
    fill: "white",
    stroke: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5753,
    y: 11.8432,
    width: 4,
    height: 4,
    rx: 1.5,
    transform: "rotate(30 29.5753 11.8432)",
    fill: "white",
    stroke: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0556,
    y: 15.2966,
    width: 12.5,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(30 18.0556 15.2966)",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7812,
    y: 7.34317,
    width: 4,
    height: 4,
    rx: 1.5,
    transform: "rotate(30 21.7812 7.34317)",
    fill: "white",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87305 20.5H13.4766V13.4072H15.2344V10.8848H13.3711V10.6562C13.3711 10.2168 13.7139 9.91797 14.5752 9.91797C14.8213 9.91797 15.085 9.93555 15.2607 9.9707V7.81738C14.8828 7.73828 14.1885 7.66797 13.5732 7.66797C10.8135 7.66797 9.87305 8.54688 9.87305 10.4805V10.8848H8.58984V13.4072H9.87305V20.5Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2944,
    y: 1.86523,
    width: 1,
    height: 6,
    transform: "rotate(30 31.2944 1.86523)",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9773,
    cy: 3.41506,
    r: 2.5,
    transform: "rotate(30 30.9773 3.41506)",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobots);
export default __webpack_public_path__ + "static/media/robots.378914ccbedc216d6c4152d2a3d380ea.svg";
export { ForwardRef as ReactComponent };